var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTranscript = function SvgTranscript(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 8.031a.353.353 0 0 0-.328-.328H5.203a.333.333 0 0 0-.328.328v.766c0 .191.137.328.328.328h4.594a.333.333 0 0 0 .328-.328v-.766ZM9.797 10H5.203a.333.333 0 0 0-.328.328v.766c0 .191.137.328.328.328h4.594a.333.333 0 0 0 .328-.328v-.766A.353.353 0 0 0 9.797 10Zm2.953-5.141c0-.328-.164-.683-.41-.929l-2.27-2.27c-.246-.246-.601-.41-.929-.41H3.563c-.739 0-1.313.602-1.313 1.313v11.375c0 .738.574 1.312 1.313 1.312h7.875c.71 0 1.312-.574 1.312-1.312V4.859Zm-3.5-2.187 2.078 2.078H9.25V2.672Zm2.188 11.266H3.563V2.563h4.375v2.843c0 .383.273.657.656.657h2.844v7.875Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTranscript, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transcript.cfeb2687.svg";
export { ForwardRef as ReactComponent };